import axios from 'axios';

const GeocoderService = {
  geocoder: async (addressData) => {
    try {
      const { data } = await axios.post('/api/routes/location/customer', addressData);

      return data;
    } catch (error) {
      console.error(error);
    }
  },
  address: async (data) => {
    try {
      const { response } = await axios.post('/api/routes/location/address', data);

      return response;
    } catch (error) {
      console.error(error);
    }
  },
  directions: async (data) => {
    try {
      const response = await axios.post('/api/routes/directions', data);
       return response.data;
    } catch (error) {
      console.error(error);
    }

  }
};

export { GeocoderService };
